import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/icon-huamianfengge.png';
const _hoisted_1 = {
  key: 0,
  class: "xhs-assistant-container"
};
const _hoisted_2 = {
  class: "left-panel"
};
const _hoisted_3 = {
  class: "left-panel-header"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "xhs-assistant-title"
};
const _hoisted_6 = {
  class: "left-panel-tip"
};
const _hoisted_7 = {
  class: "left-panel-tip-title"
};
const _hoisted_8 = {
  class: "custom-el-input-textarea custom-el-input left-panel-input"
};
const _hoisted_9 = {
  class: "left-panel-tip"
};
const _hoisted_10 = {
  class: "left-panel-tip-title"
};
const _hoisted_11 = {
  class: "left-panel-word-limit"
};
const _hoisted_12 = {
  class: "left-panel-tip"
};
const _hoisted_13 = {
  class: "left-panel-tip-title"
};
const _hoisted_14 = {
  class: "left-panel-select"
};
const _hoisted_15 = {
  class: "left-panel-footer"
};
const _hoisted_16 = {
  key: 0,
  class: "ri-loader-line animate-spin"
};
const _hoisted_17 = {
  class: "right-panel"
};
const _hoisted_18 = {
  key: 0,
  class: "right-panel-generate-content"
};
const _hoisted_19 = {
  class: "right-panel-content"
};
const _hoisted_20 = {
  key: 1,
  class: "xhs-assistant-detail"
};
import { ref, onMounted, watch } from 'vue';
import SmartContentWorkshop from '@/views/smartContentWorkshop/index.vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { fetchCopywritingAssistant } from '@/request/aiAction';
import GeneratedContentList from './components/GeneratedContentList.vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    scene: {}
  },
  setup(__props) {
    const router = useRouter();
    const props = __props;
    const defaultValues = ref({}); // 默认值
    const historyList = ref([]); // 创作历史列表
    const isGenerating = ref(false); // 是否正在生成
    const generateList = ref([]); // 生成列表
    const isGenerateLoading = ref(false); // 是否正在生成
    const showWorkshop = ref(true); // 是否显示工作坊
    const typeName = ref('xhs-assistant-public-history-list'); // 类型名称
    const curId = ref(''); // 当前id
    // 添加 watch
    watch(() => props.scene, newScene => {
      // 根据新的 scene 重新生成 defaultValues
      defaultValues.value = {};
      defaultValues.value = newScene.recorder.componentsList.reduce((acc, item) => {
        console.log('item', item);
        acc[item.key] = item.value;
        return acc;
      }, {});
      console.log('defaultValues', defaultValues.value);
    }, {
      immediate: true
    } // immediate: true 确保组件初始化时也会执行一次
    );
    // 插入示例
    const insertExample = () => {
      props.scene.recorder.componentsList.forEach(item => {
        if (item.type === 'input' && item.componentProps.placeholder) {
          defaultValues.value[item.key] = item.componentProps.placeholder;
        }
      });
    };
    // 删除
    const handleDelete = item => {
      const temp = historyList.value.findIndex(item => item.id === item.id);
      if (temp !== -1) {
        historyList.value.splice(temp, 1);
      }
      localStorage.setItem('xhs-assistant-public-history-list', JSON.stringify(historyList.value));
    };
    const goBack = () => {
      showWorkshop.value = true;
      // 刷新数据
      // window.location.reload();
      getHistoryList();
      generateList.value = [];
      isGenerating.value = false;
    };
    // 点击
    const handleClick = item => {
      if (item !== null && item !== void 0 && item.loading || isGenerateLoading.value) {
        ElMessage.warning('文案正在生成中，请耐心等待...');
      } else {
        showWorkshop.value = false;
        curId.value = item.id;
      }
    };
    const generateContent = async () => {
      try {
        // 检查所有必填输入项
        const missingRequiredInputs = props.scene.recorder.componentsList.filter(item => {
          // 检查是否是必填项且值为空 输入框默认必填
          if (item.type === 'input') {
            return !defaultValues.value[item.key];
          }
          return item.isRequired && !defaultValues.value[item.key];
        });
        if (missingRequiredInputs.length > 0) {
          // 如果有必填项未填写，显示提示信息
          ElMessage.warning(`请先输入你想生成文案才能生成优质文案哟！`);
          return;
        }
        isGenerateLoading.value = true;
        isGenerating.value = true;
        generateList.value = [];
        // Generate two placeholders with unique IDs
        const placeholders = Array(3).fill(null).map(() => ({
          id: Date.now().toString(36) + Math.random().toString(36).substr(2),
          loading: true,
          name: props.scene.name,
          img: props.scene.img
        }));
        // Add a small delay between generating IDs to ensure uniqueness
        await new Promise(resolve => setTimeout(resolve, 1));
        generateList.value.unshift(...placeholders);
        const generatedContents = await fetchGeneratedContents(placeholders);
        // 更新生成列表和历史列表
        generateList.value = generateList.value.map(item => generatedContents.find(content => content.id === item.id) || item);
        historyList.value.unshift(...generatedContents);
        localStorage.setItem('xhs-assistant-public-history-list', JSON.stringify(historyList.value));
        ElMessage.success('内容生成成功');
      } catch (error) {
        console.error('生成内容时出错:', error);
      } finally {
        isGenerateLoading.value = false;
      }
    };
    const fetchGeneratedContents = async placeholders => {
      const updateGenerateList = (id, content) => {
        const index = generateList.value.findIndex(item => item.id === id);
        if (index !== -1) {
          generateList.value[index] = content;
        }
      };
      // 添加重试生成内容的函数
      const generateWithRetry = async (placeholder, retryCount = 0) => {
        const MAX_RETRIES = 3; // 最大重试次数
        try {
          var _json$data;
          const response = await fetchCopywritingAssistant(props.scene.requestData, defaultValues.value);
          if (!response.ok) {
            throw new Error(`Network response error: ${response.status}`);
          }
          const json = await response.json();
          if (!((_json$data = json.data) !== null && _json$data !== void 0 && (_json$data = _json$data.outputs) !== null && _json$data !== void 0 && _json$data.text)) {
            throw new Error('Invalid response format');
          }
          let outputObject;
          try {
            const {
              outputs
            } = json.data;
            const cleanedText = outputs.text.replace(/```json\n|\n```/g, '');
            outputObject = JSON.parse(cleanedText.trim());
          } catch (parseError) {
            throw new Error('Failed to parse response text as JSON');
          }
          // 检查 context 是否为空,如果为空且未超过重试次数则重试
          if (!outputObject.context && retryCount < MAX_RETRIES) {
            console.log(`Empty context received, retrying... (${retryCount + 1}/${MAX_RETRIES})`);
            return generateWithRetry(placeholder, retryCount + 1);
          }
          if (outputObject.context) {
            outputObject.contextHtml = outputObject.context.includes('\n') ? outputObject.context.replace(/\n/g, '<br>') : outputObject.context;
          }
          const temp = {
            name: props.scene.name,
            img: props.scene.img,
            desc: props.scene.desc,
            title: outputObject.title || props.scene.name,
            context: outputObject.context || '',
            tag: outputObject.tag || '',
            contextHtml: outputObject.contextHtml || ''
          };
          const content = {
            ...temp,
            ...placeholder,
            generatedTime: new Date().toISOString(),
            loading: false
          };
          updateGenerateList(placeholder.id, content);
          return content;
        } catch (error) {
          if (retryCount < MAX_RETRIES) {
            console.log(`Error occurred, retrying... (${retryCount + 1}/${MAX_RETRIES})`);
            return generateWithRetry(placeholder, retryCount + 1);
          }
          console.error('Error details:', error);
          generateList.value = generateList.value.filter(item => item.id !== placeholder.id);
          return null;
        }
      };
      const requests = placeholders.map(placeholder => generateWithRetry(placeholder));
      const results = await Promise.all(requests);
      return results.filter(Boolean);
    };
    const getHistoryList = () => {
      // 从本地获取小红书通用文案列表
      const localHistoryList = localStorage.getItem('xhs-assistant-public-history-list') || '[]';
      historyList.value = JSON.parse(localHistoryList);
    };
    onMounted(() => {
      // 从本地获取小红书通用文案列表
      getHistoryList();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_divider = _resolveComponent("el-divider");
      return showWorkshop.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: props.scene.img,
        fit: "contain",
        class: "xhs-assistant-logo"
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(props.scene.name), 1)]), _createVNode(_component_el_scrollbar, {
        class: "left-panel-content"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.scene.recorder.componentsList, item => {
          return _openBlock(), _createElementBlock(_Fragment, null, [item.type === 'input' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("i", {
            class: "ri-brush-ai-fill"
          }, null, -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(item.tip), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, _mergeProps({
            ref_for: true
          }, item.componentProps, {
            class: "content-input",
            modelValue: defaultValues.value[item.key],
            "onUpdate:modelValue": $event => defaultValues.value[item.key] = $event
          }), null, 16, ["modelValue", "onUpdate:modelValue"])])], 64)) : item.type === 'radio' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_9, [_cache[1] || (_cache[1] = _createElementVNode("i", {
            class: "ri-bard-fill"
          }, null, -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(item.tip), 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_radio_group, {
            modelValue: defaultValues.value[item.key],
            "onUpdate:modelValue": $event => defaultValues.value[item.key] = $event,
            size: "large"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, option => {
              return _openBlock(), _createBlock(_component_el_radio_button, {
                key: option.value,
                label: option.label,
                value: option.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])], 64)) : item.type === 'select' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("div", _hoisted_12, [_cache[2] || (_cache[2] = _createElementVNode("i", {
            class: "ri-bard-fill"
          }, null, -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(item.tip), 1)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_select, {
            modelValue: defaultValues.value[item.key],
            "onUpdate:modelValue": $event => defaultValues.value[item.key] = $event,
            size: "large"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, option => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: option.value,
                label: option.label,
                value: option.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])], 64)) : _createCommentVNode("", true)], 64);
        }), 256))]),
        _: 1
      }), _createElementVNode("div", {
        class: "left-panel-create-example"
      }, [_createElementVNode("div", {
        class: "create-example-btn",
        onClick: insertExample
      }, _cache[3] || (_cache[3] = [_createElementVNode("div", {
        class: "create-example-btn-content"
      }, [_createElementVNode("img", {
        src: _imports_0,
        fit: "contain",
        class: "create-example-btn-img"
      }), _createElementVNode("span", null, "不知道写啥？试试插入示例")], -1)]))]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
        disabled: isGenerateLoading.value,
        class: "generate-btn",
        onClick: generateContent
      }, {
        default: _withCtx(() => [isGenerateLoading.value ? (_openBlock(), _createElementBlock("i", _hoisted_16)) : _createCommentVNode("", true), _cache[4] || (_cache[4] = _createElementVNode("span", null, "立即生成", -1))]),
        _: 1
      }, 8, ["disabled"])])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_scrollbar, {
        class: "right-panel-scrollbar"
      }, {
        default: _withCtx(() => [isGenerating.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(GeneratedContentList, {
          historyList: generateList.value,
          typeTitle: props.scene.name,
          title: "本次创作结果",
          showDelete: false,
          onHandleDelete: handleDelete,
          onHandleClick: handleClick
        }, null, 8, ["historyList", "typeTitle"]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createVNode(GeneratedContentList, {
          historyList: historyList.value,
          typeTitle: props.scene.name,
          title: "创作历史",
          onHandleDelete: handleDelete,
          onHandleClick: handleClick
        }, null, 8, ["historyList", "typeTitle"])])]),
        _: 1
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(SmartContentWorkshop, {
        onGoBack: goBack,
        typeName: typeName.value,
        id: curId.value
      }, null, 8, ["typeName", "id"])]));
    };
  }
});